import ServicesHero from './components/ServicesHero';
import AIDataRD from './components/AIDataRD';
import SystemReconstruction from './components/SystemReconstruction';
import CustomSolution from './components/CustomSolution';

export default function ServicesPage() {
  return (
    <div className="pt-20">
      <ServicesHero />
      <AIDataRD />
      <SystemReconstruction />
      <CustomSolution />
    </div>
  );
}
